import classNames from 'classnames'
import { Component } from 'preact'

export interface TextFieldProps {
  name: string
  ariaLabel: string
  id: string
  label?: string
  subtext?: string
  isControl?: boolean
  isInline?: boolean
  enableFocusToInput?: boolean
  updateInputValue?: string
  placeholder?: string
  defaultValue?: string
  direction?: 'vertical' | 'horizontal'
  size?: 'S' | 'M' | 'L' | 'fullWidth'
  onChange?: (value: string) => void
  onKeyUp?: (value: string) => void
}

interface State {
  inputValue: string
}

class TextField extends Component<TextFieldProps, State> {
  input?: HTMLInputElement

  constructor(props: TextFieldProps) {
    super(props)

    this.state = {
      inputValue: props.defaultValue ?? ''
    }

    this.handleOnChange = this.handleOnChange.bind(this)
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this)
  }

  handleOnChange(value: string) {
    this.setState({
      inputValue: value
    })

    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(value)
    }
  }

  handleOnKeyUp(value: string) {
    this.setState({
      inputValue: value
    })
    if (this.props.onKeyUp && typeof this.props.onKeyUp === 'function') {
      this.props.onKeyUp(value)
    }
  }

  componentDidUpdate(previousProps: Readonly<TextFieldProps>) {
    if (
      previousProps.enableFocusToInput !== this.props.enableFocusToInput &&
      this.props.enableFocusToInput &&
      this.input
    ) {
      this.input.focus()
      setTimeout(() => {
        if (this.input) {
          this.input.focus()
        }
      }, 100)
    }
    if (
      previousProps.updateInputValue !== this.props.updateInputValue &&
      typeof this.props.updateInputValue === 'string' &&
      this.input
    ) {
      this.input.value = this.props.updateInputValue
      this.setState({ inputValue: this.props.updateInputValue })
      this.handleOnChange(this.props.updateInputValue)
      this.handleOnKeyUp(this.props.updateInputValue)
    }
  }

  render(props: TextFieldProps, { inputValue }: State) {
    const { name, ariaLabel, id, label, subtext, placeholder = '' } = props
    return (
      <div
        className={classNames(
          'a-text-field',
          `a-text-field--size-${props.size ?? 'fullWidth'}`,
          `a-text-field--direction-${props.direction ?? 'vertical'}`,
          {
            'a-text-field--type-inline': props.isInline,
            'a-text-field--app-control': props.isControl,
            'a-text-field--app-destination': !props.isControl
          }
        )}
      >
        {Boolean(label) && (
          <label className='a-text-field--label' for={id}>
            {label}
          </label>
        )}
        {Boolean(subtext) && <p className='a-text-field--subtext'>{subtext}</p>}
        <input
          ref={(input: HTMLInputElement) => {
            this.input = input
          }}
          placeholder={placeholder}
          className='a-text-field--input'
          id={id}
          name={name}
          aria-label={ariaLabel}
          value={inputValue}
          onChange={(event) => this.handleOnChange((event.target as HTMLInputElement).value)}
          onKeyUp={(event) => this.handleOnKeyUp((event.target as HTMLInputElement).value)}
        />
      </div>
    )
  }
}

export default TextField
